import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { required } from 'redux-form-validators';

import { DefaultButton, AsyncSelectField } from 'common/components';

import { FormattedMessage } from 'react-intl';

import { editTransfer } from 'backoffice/transfers/_redux';
import staticStyles from './style';
import { getBackofficeManagerList } from '../../api';

const editTransferManagerForm = ({ handleSubmit, pristine, submitting, invalid, dispatch, error, id }) => {
  const submit = handleSubmit(values => {
    editTransfer({ id, ...values }, dispatch);
  });

  const loadOptions = search =>
    getBackofficeManagerList(search).then(({ data }) =>
      data.map(manager => ({ value: manager.id, label: `${manager.firstName} ${manager.lastName}` }))
    );

  return (
    <div className="RejectModal__content">
      <form className="editTransferManagerForm" onSubmit={submit}>
        <FormattedMessage id="editManagerDescription">
          {txt => <p className="EditUserManagerForm__description">{txt}</p>}
        </FormattedMessage>
        <div className="EditUserManagerForm__inputs-inner">
          <Field
            textId="justManager"
            component={AsyncSelectField}
            name="manager"
            loadOptions={loadOptions}
            validate={[required()]}
            disabled={submitting}
            maxMenuHeight={270}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            menuPortalTarget={document.body}
          />
        </div>

        <DefaultButton
          textId="justChange"
          type="submit"
          loading={submitting}
          disabled={invalid || pristine || submitting}
          filled
        />
        {error && <strong className="formError">{error}</strong>}
      </form>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

editTransferManagerForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
};

editTransferManagerForm.defaultProps = {
  error: '',
};

export default reduxForm({
  form: 'editTransferManagerForm',
})(editTransferManagerForm);
export { editTransferManagerForm };
